export enum InternationalizationNameSpace {
  Core = 'CORE',
  Auth = 'AUTH',
  Maintenance = 'MAINTENANCE',
  Assets = 'ASSETS',
  Companies = 'COMPANIES',
  Dashboard = 'DASHBOARD',
  Map = 'MAP',
  RoboticMowerCodes = 'MOWER_ERROR_CODES',
  Faq = 'FAQ',
  CookiePolicy = 'COOKIEPOLICY',
  Status = 'statusTranslation',
  Dealers = 'DEALERS',
  ErrorCode = 'errorCodesTranslation.robotics.wm',
  Changelog = 'CHANGELOG',
  ThirdPartySoftware = 'THIRD_PARTY_SOFTWARE',
}

export enum InternationalizationBackendNameSpace {
  Status = 'statusTranslation',
  ErrorCode = 'errorCodesTranslation.robotics.wm',
  IncidentCommunication = 'incidentCommunicationTranslation',
}
